import { clear, unprefix } from '../../../helpers/compact';
import { toText } from '../fields/text';

export const contact = (data) => {
  const { firstname_lastname, job_position, phone, email } = unprefix(
    'contact',
    data
  );
  const name = toText(firstname_lastname);
  if (name) {
    return clear({
      fullName: toText(firstname_lastname),
      job: toText(job_position),
      phone: toText(phone),
      email: toText(email),
    });
  }
};
